<template>
    <div class="flex flex-wrap items-center justify-center">
        <meta-text x-small class="leading-loose"><nuxt-link :to="$spoferanUrl('/imprint')" class="text-gray-450 hover:text-primary">{{ $t('label.imprint') }}</nuxt-link></meta-text>
        <meta-text x-small class="leading-loose"><nuxt-link :to="$spoferanUrl('/gtc')" class="text-gray-450 hover:text-primary">{{ $t('label.gtc') }}</nuxt-link></meta-text>
        <meta-text x-small class="leading-loose"><nuxt-link :to="$spoferanUrl('/privacy-policy')" class="text-gray-450 hover:text-primary">{{ $t('label.privacy') }}</nuxt-link></meta-text>
        <meta-text x-small class="leading-loose text-gray-450">&copy; {{ new Date().getFullYear() }} <nuxt-link :to="$spoferanUrl()" class="text-gray-450 hover:text-primary">SPOFERAN</nuxt-link></meta-text>
    </div>
</template>
<script setup lang="ts">

</script>